/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Skrill = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M12.0960564,9.62514852 C11.5061194,9.58655304 10.140314,9.49879133 10.140314,8.2762732 C10.140314,6.80104069 12.1066881,6.80104069 12.8442329,6.80104069 C14.1410558,6.80104069 15.8206206,7.18207891 17.0200272,7.53877986 C17.0200272,7.53877986 17.6890839,7.77330274 18.2584992,8.01347974 L18.3114106,8.02773794 L18.3114106,3.98750359 L18.2387192,3.96611628 C16.8232167,3.47371656 15.1772778,3 12.1257263,3 C6.86426011,3 5,6.04756832 5,8.65829475 C5,10.1632728 5.6487823,13.7052075 11.6744962,14.1137788 C12.1853134,14.1449994 13.5409816,14.222682 13.5409816,15.4860081 C13.5409816,16.5290695 12.4310792,17.144139 10.5643466,17.144139 C8.51860551,17.144139 6.53418222,16.6254353 5.32884164,16.1335273 L5.32884164,20.2947105 C7.1332674,20.7649855 9.16738781,21 11.5513661,21 C16.6958833,21 19,18.1166469 19,15.2588602 C19,12.0185602 16.4216838,9.91326259 12.0960564,9.62514852 Z"
    />
  </Icon>
);
